<template>
  <div class="mysource">
    <Header></Header>
    <div class="content" v-if="JSON.stringify(detailsObj) !== '{}'">
      <div class="main">
        <h4>{{ detailsObj.ExamPaperName }}</h4>
        <p class="success">交卷成功</p>
        <div class="btn">
          <a :href="'/CheckExamAnswer?examID=' + paperId + '&recordId=' + recordId" style="margin-right:0">查看答案</a>
        </div>
        <ul class="details">
          <li class="one">
            <span>得分</span>
            <label style="color:#ff0000">{{ detailsObj.ExamRecord.TotalScore }}</label>
          </li>
          <li class="two">
            <span>用时</span>
            <label>{{ diffTime(new Date(detailsObj.ExamRecord.StartTime), new Date(detailsObj.ExamRecord.EndTime)) }}</label>
          </li>
          <li class="three">
            <span>答对</span>
            <label>{{ detailsObj.ExamRecord.TotalRightQuestions }}道</label>
          </li>
        </ul>
        <h6>实时排名</h6>
        <table>
          <tbody>
            <tr>
              <td width="16.6%">全网排名</td>
              <th width="16.6%" class="boldsize">{{ detailsObj.ExamRecord.RankNo }}</th>
              <td width="16.6%">地区排名</td>
              <th width="16.6%" class="boldsize">{{ detailsObj.ExamRecord.CityRankNo }}</th>
              <td width="16.6%">学校排名</td>
              <th width="16.6%" class="boldsize">{{ detailsObj.ExamRecord.SchoolRankNo }}</th>
            </tr>
          </tbody>
        </table>
        <h6>答题情况</h6>
        <table>
          <tbody>
            <tr>
              <th style="width: 250px;"></th>
              <th class="boldsize">分数</th>
              <th class="boldsize">答对试题</th>
              <th class="boldsize">答错试题</th>
              <th class="boldsize">未做试题</th>
              <th class="boldsize">正确率</th>
            </tr>
            <tr class="change_part" v-for="(item, index) in detailsObj.ExamPartList" :key="index">
              <td>{{ item.ExamPartName }}</td>
              <td>{{ item.PartTotalScore<0?0:item.PartTotalScore }}</td>
              <td>{{ item.TotalRightQuestions }}</td>
              <td>{{ item.TotalErrorQuestions }}</td>
              <td>{{ item.TotalUnDoQuestions }}</td>
              <td>{{ item.RightRate == 0 ? '0' : item.RightRate }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
export default {
  name: 'SelectExam',
  components: {
    Header
  },
  data() {
    return {
      paperId: '',
      recordId: '',
      detailsObj: {},
    }
  },
  mounted() {
    this.paperId = this.$route.query.ExamPaperId
    this.recordId = this.$route.query.ExamRecordId
    this.getRecord()
  },
  methods: {
    getRecord() {
      this.$api.HJFinishExam({ recordId: this.recordId }).then(res => {
        if (res.Success) {
          this.detailsObj = res.Data
        } else this.$message.error(res.Msg)
      })
    },
    diffTime(date1, date2) {
      const msPerMinute = 60 * 1000;
      const msPerSecond = 1000;
      const diffInMs = Math.abs(date2 - date1);
      const minutes = Math.floor(diffInMs / msPerMinute);
      const seconds = Math.floor((diffInMs % msPerMinute) / msPerSecond);

      return `${minutes}分${seconds}秒`;
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  padding-top: 86px;
  height: 100%;
  overflow: hidden;
}

.content {
  background: #fafafa;
  overflow: hidden;
}

.main {
  margin: 0 auto;
  zoom: 1;
  width: 1200px;
  float: none;
}

.content h4 {
  font-size: 24px;
  color: #666666;
  text-align: center;
  padding: 70px 0;
}

.content .success {
  font-size: 30px;
  color: rgb(255, 88, 88);
  text-align: center;
  font-family: 宋体;
  font-weight: bold;
}

.content .btn {
  text-align: center;
  padding: 30px;
  border-bottom: 1px dashed #999999;
}

element.style {
  margin-right: 0;
}

.content .btn a {
  width: 267px;
  height: 48px;
  display: inline-block;
  font-size: 16px;
  color: #666666;
  background: #e6e6e6;
  line-height: 48px;
  margin-right: 35px;
}

a {
  text-decoration: none;
}

.content .btn a {
  width: 267px;
  height: 48px;
  display: inline-block;
  font-size: 16px;
  color: #666666;
  background: #e6e6e6;
  line-height: 48px;
  margin-right: 35px;
}

.content .details {
  overflow: hidden;
  padding: 20px 0 40px;
  zoom: 1;
}

ul {
  list-style: none;
}

.content .details li {
  float: left;
  overflow: hidden;
  zoom: 1;
}

.content .details .one {
  width: 325px;
}

.content .details li span {
  font-size: 16px;
  color: #666666;
  line-height: 90px;
  background-image: url(../assets/img/jb.png);
  background-repeat: no-repeat;
  background-position: center 0;
  height: 90px;
  display: inline-block;
  line-height: 90px;
  float: left;
}

.content .details label {
  float: left;
  margin-left: 30px;
  font-size: 48px;
  color: #17b7f2;
}

.content .details .two {
  width: 462px;
}

.content .details .two span {
  background-image: url(../assets/img/time.png);
}

.content .details .three {
  width: 202px;
}

.content .details .three span {
  background-image: url(../assets/img/yes.png);
}

.content h6 {
  font-size: 16px;
  color: #666666;
  font-weight: bold;
  margin-bottom: 30px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
}

th,
td {
  border: 1px solid #fff;
  padding: 18px 0;
  text-align: center;
  font-size: 14px;
  color: #666666;
  font-weight: normal;
}

.content table {
  width: 100%;
  border-collapse: collapse;
  background: #e6e6e6;
  margin-bottom: 90px;
}

.content table td {
  border: 1px solid #ffffff;
  font-size: 16px;
}

.boldsize {
  font-weight: bold;
  color: #17b7f2;
}
</style>